import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledExpandableSection = styled(UIExpandableSection).withConfig({
  displayName: "FieldGroup__StyledExpandableSection",
  componentId: "sc-184m29j-0"
})(["&:first-of-type > div{border-top:0 !important;}"]);
const FieldGroup = ({
  children,
  defaultOpen,
  expandable,
  headerSecondaryContent,
  label
}) => {
  if (expandable) {
    return /*#__PURE__*/_jsx(StyledExpandableSection, {
      defaultOpen: defaultOpen,
      titleText: label,
      indentation: "none",
      children: children
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIMediaObject, {
      align: "baseline",
      itemRight: headerSecondaryContent,
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: label && /*#__PURE__*/_jsx("h5", {
          children: /*#__PURE__*/_jsx("span", {
            className: "m-right-1",
            children: label
          })
        })
      })
    }), children]
  });
};
FieldGroup.propTypes = {
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
  expandable: PropTypes.bool,
  headerSecondaryContent: PropTypes.node,
  label: PropTypes.string
};
export default FieldGroup;